import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Article, DocsHeader, DocsHeading, Section } from "./Components";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import {
    faAward
} from "@fortawesome/free-solid-svg-icons";

const Tack = ({ setSection, setArticle }) => (
    <Article id="tack" name="Tack" icon={faAward} setArticle={setArticle} setSection={setSection}>
        <DocsHeader>
            <DocsHeading note="Updaterad: 2022-07-13">Tack</DocsHeading>
        </DocsHeader>
        <Section id="people" name="Tack" active={true}>
            <p>Tack till de som bidragit med material och text till det här dokumentet. Även tack till de som är
                med på bilder.</p>
            <p>De som bidragit är</p>
            <ul>
                <li>Alex</li>
                <li>Elin</li>
                <li>Johanna</li>
                <li>Håkan</li>
            </ul>
            <p>/Alex</p>
        </Section>
    </Article>
)

const Footer = ({ setSection, setArticle }) =>
(<footer className="footer">
    <div className="container text-center py-5">
        <small className="copyright">
            {"© 2022 - " + new Date().getFullYear() + " Alexander Anderson"} &nbsp;
        </small>
        <small className="copyright">Designed with<FontAwesomeIcon icon={faHeart} /> by
            <a className="theme-link" href="http://themes.3rdwavemedia.com" target="_blank">Xiaoying
                Riley</a> for developers</small>
    </div>
</footer>);

export { Tack, Footer };